import { useEffect } from "react";

import { SessionStorageConstants } from "../../constants";
import { safeSessionStorage } from "../storage";

export const useShowBrowserConfirmationDialog = (): void => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
      if (!safeSessionStorage.getItem(SessionStorageConstants.Deal_Journey_Data)) return;

      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);
};
